import React from 'react';
import styled from 'styled-components';

import LocationSvg from '../assets/hotels/home/location.svg';
import {defaultTheme} from 'build-theme/src/build-theme';

const LocationIcon = styled(LocationSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill || defaultTheme.colors.grey.grey50};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default LocationIcon;
